var _defs, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fca400;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-3 {\n        fill: #f5ca77;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 64,
    cy: 64,
    r: 63.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.7,47.9s7.9-11.2,16.1-16.9,15-9.2,19.3-9.6c4.3-.4,5.8.1,7.1,4.8,1.3,4.7,1.4,18.2-2.3,28.9s-5.2,13.5-7.7,17c-2.5,3.4-3.8,3.9-6.2,3.1-2.8-1-5.9-10-7.7-12.4-1.8-2.4-.8-3.7-11.2-4.2-8.2-.3-9.6-.2-10.5-2.5s3-8.1,3-8.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M64.2,65.5c-1.5-.5-2.7,1.5-2.7,1.5,0,0-16.9,20.5-26.2,28.8-8.6,7.5-17.6,10.3-19,10.8,2,2.2,4.1,4.3,6.4,6.3,2,.4,9.4,1.8,17.3.6,9.2-1.4,12.4-11.5,12.4-11.5,0,0,13.1-32.4,13.5-33.5.4-1.1-.2-2.3-1.6-2.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.df496dad3f3f4ac9ba50dab3e54b6c85.svg";
export { ForwardRef as ReactComponent };